<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-13 14:28:38
 * @Description: 
-->
<template>
    <GameSettingsButtonWrapper
        :enable="modelValue"
        @click="onClick()"
        @mouseleave="onMouseLeave()"
        @mouseenter="onMouseEnter"
    >
        <!--
            ↓ 音乐图标，添加 ClientOnly，以此防止 Hydration 报错！！！！！！！！！！
            ↓ 因为只有在客户端能查询到音乐的启用状态，并决定用哪个 QIcon 
        -->
        <ClientOnly>
            <QIcon :name="modelValue ? 'volume_up' : 'volume_off'"/>
        </ClientOnly>
        <!-- ↓ 弹出的操作区小气泡 -->
        <QTooltip
            no-parent-event
            anchor="bottom right"
            self="top right"
            :offset="[0, 15]"
            v-model="toolTipModel"
            volumeTip="volumeTip"
            @mouseleave="onMouseLeave()"
            @mouseenter="onMouseEnter"
        >
            <q-slider
                class="w-[90px] h-2"
                :max="1"
                :step="0.01"
                :min="0"
                :model-value="voiceModelValue"
                @update:model-value="emit('update:voiceModelValue', $event)"
            ></q-slider>
        </QTooltip>
        <!-- 👇插入的音频 -->
        <slot name="audio"></slot>
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import useSettingsStore from '~/stores/settings';

const settingStore = useSettingsStore();

const props = defineProps({
    modelValue: {
        // 是否开启音乐
        type: Boolean,
        default: false,
    },
    voiceModelValue: {
        // 音量
        type: Number,
        required: true,
    },
    saveAfterChange: {
        // 是否在变更后保存到 settings
        type: Boolean,
    },
});

const emit = defineEmits(['update:modelValue', 'update:voiceModelValue']);
const toolTipModel = ref(false);

let timers = [];

const onMouseEnter = () => {
    timers.forEach(clearTimeout);
    timers.splice(0, 1/0);
    toolTipModel.value = true;
};

const onMouseLeave = () => {
    const iDealy = Reflect.has(window, 'ontouchstart') ? 0 : 500;
    timers.push(setTimeout(() => (toolTipModel.value = false), iDealy));
};

const onClick = () => {
    emit('update:modelValue', !props.modelValue);
};

watch(
    () => props.modelValue,
    () => {
        if (props.modelValue) {
            emit('update:voiceModelValue', 0.5);
        } else {
            emit('update:voiceModelValue', 0);
        }
        toRecordMusicSetting();
    },
);

watch(
    () => props.voiceModelValue,
    () => {
        if (props.voiceModelValue === 0) emit('update:modelValue', false);
        else emit('update:modelValue', true);
        toRecordMusicSetting();
    },
);

// 👇在音乐设定变化后保存到 settingStore
function toRecordMusicSetting() {
    if (!props.saveAfterChange) return;
    settingStore.$patch({
        inhouseGames: {
            ...settingStore.inhouseGames,
            sound: {
                on: !!props.modelValue,
                music: props.voiceModelValue,
                effects: props.voiceModelValue,
            },
        },
    });
}
</script>


<style lang="scss">
body > * > .q-tooltip[volumeTip='volumeTip'] {
    pointer-events: auto !important;
}
</style>